<script setup lang="ts">
import { RouterView } from 'vue-router'
import AppHeader from './components/layout/AppHeader.vue'
import { useAuth } from './composables/useAuth'
import { useI18nHead } from './composables/useI18nHead'

// Initialize auth state on app load
const { checkAuth } = useAuth()
checkAuth()

// Set i18n-aware <head> tags
useI18nHead()
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <AppHeader />
    <main class="flex-1">
      <RouterView />
    </main>
  </div>
</template>
